module.exports = __webpack_public_path__ + "img/home.fe95db00.png";